import { CustomerDetails, BokerPacket, ClentPolicyOrganiser, GPFAFirstStep, PolicyReview, LicensingGuide } from "./PDFs";

export const formsData = [
  {
    name: "Annuity Case Design Request",
    description: "Annuity Case Design Request from Simplicity, Please fill the required fields and send to simplicity email provided.",
    data: CustomerDetails,
    fileName: "customer_details.pdf"
  }
];

export const documentData = [
  {
    name: "Brockers Packet Complete",
    description: "Some text to display for user to understand about document content",
    thumb_nail: "brokers_pocket.png",
    data: BokerPacket,
    fileName: "borker_packet.pdf"
  },
  {
    name: "Client Policy Organizer",
    description: "Some text to display for user to understand about document content",
    thumb_nail: "client_policy.png",
    data: ClentPolicyOrganiser,
    fileName: "client_policy_organization.pdf"
  },
  {
    name: "GPFA First Step",
    description: "Some text to display for user to understand about document content",
    thumb_nail: "gpfa_first_step.png",
    data: GPFAFirstStep,
    fileName: "gpfa_first_step.pdf"
  },
  {
    name: "GPFA Policy Review Script",
    description: "Some text to display for user to understand about document content",
    thumb_nail: "policy_review.png",
    data: PolicyReview,
    fileName: "gpfa_policy_review.pdf"
  },
  {
    name: "GPFA Life and Health Licensing Guide",
    description: "Some text to display for user to understand about document content",
    thumb_nail: "licensing_guide.png",
    data: LicensingGuide,
    fileName: "gpfa_licensing_guide.pdf"
  }
];